import apiClient from "@/shared/api/apiClient";

export const getNotariesInfo = async (params) => {
  try {
    const { data } = await apiClient.get(
      "/notaries/info",
      {
        params,
      },
      {
        metaData: { isNotificationDisabled: true },
      }
    );
    return data;
  } catch (e) {
    console.error("[session/notaries] getNotariesInfo", e);
  }
};

export const getNotaryListForSelection = async (params = {}) => {
  try {
    const query = {
      page: params.page ?? 1,
      page_size: params.page_size ?? 20,
      identifier: params.identifier ?? "",
      first_name: params.first_name ?? "",
      last_name: params.last_name ?? "",
      middle_name: params.middle_name ?? "",
    };
    if (params.organization_id != null) {
      query.organization_id = params.organization_id;
    }
    if (
      Array.isArray(params.notarial_actions_codes) &&
      params.notarial_actions_codes.length
    ) {
      query.notarial_actions_codes = params.notarial_actions_codes;
    }
    const { data } = await apiClient.get("/notaries/notaries-list/", {
      params: query,
      paramsSerializer: { indexes: null },
    });
    if (data?.payload && typeof data.payload === "object") return data.payload;
    if (Array.isArray(data?.items)) return data;
    return { items: [], total: 0 };
  } catch (e) {
    console.error("[getNotaryListForSelection]", e);
    return { items: [], total: 0 };
  }
};
